import { render, staticRenderFns } from "./CulvertTable.vue?vue&type=template&id=63442dd0&scoped=true"
import script from "./CulvertTable.vue?vue&type=script&lang=ts"
export * from "./CulvertTable.vue?vue&type=script&lang=ts"
import style0 from "./CulvertTable.vue?vue&type=style&index=0&id=63442dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63442dd0",
  null
  
)

export default component.exports